/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { createContext, useContext, useReducer } from 'react';
import {enCrypt, deCrypt } from "../api/enCrypt";

export const UserContext = createContext(null);
export const UserDispatchContext = createContext(null);

export function UserProvider({ children }) {
    const [state, dispatch] = useReducer(
        UserReducer, 
        InitialState
    );
  
    return (
        <UserContext.Provider value={state}>
            <UserDispatchContext.Provider value={dispatch}>
                {children}
            </UserDispatchContext.Provider>
        </UserContext.Provider>
  );
}

export function useUserContext() {
    return useContext(UserContext);
}
  
export function useUserDispatch() {
    return useContext(UserDispatchContext);
}
  

   const InitialState = {
        isLogin: false,
        user: null,
        notice: 0
    }



 function UserReducer(state, action) {
    //   console.log(state);
    //   console.log(action);
        switch (action.type) {
            case 'login': {
                const token = enCrypt(JSON.stringify(action.user));
                sessionStorage.setItem("token", token);
                // console.log(token);
                return {
                isLogin: true,
                user: action.user,
                notice: 0
                }

            }
            case 'changed': {
                return state.map(t => {
                    if (t.user.id === action.user.id) {
                        return action.state;
                    } else {
                        return t;
                    }
                });
            }
            case 'logout': {
                sessionStorage.clear();
                return InitialState;
            }
            default: {
                throw Error('Unknown action: ' + action.type);
            }
        }
    }
  